import { Atlas } from './ResourceManager';

export const atlasesContext = require.context('../../../resource/graphics/sprite_sheets', false, /\.json$/);

export function getAtlasByUrl(url?: string): Atlas | null {
    if (!url) {
        return null;
    }

    const fileName = url.split('/').pop();
    const key = `./${fileName}`;

    if (atlasesContext.keys().includes(key)) {
        return atlasesContext(key);
    }

    return null;
}
